import {KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {CloseOutlined} from '@ant-design/icons'

const MaDinhDanhInfoModalHeader = () => {
  const {itemIdForInfo, setItemIdForInfo} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      {itemIdForInfo === '0' && <h2 className='fw-bolder'>Thông tin mã định danh</h2>}
      {itemIdForInfo && itemIdForInfo?.length > 1 && (
        <h2 className='fw-bolder'>Thông tin mã định danh</h2>
      )}
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForInfo('')}
        style={{cursor: 'pointer'}}
      >
        <CloseOutlined style={{fontSize: '16px'}} />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {MaDinhDanhInfoModalHeader}
